<script setup lang="ts">
import { NxtInput, NxtTextEditor, NxtToggle } from '@future-harry/nxt-styles';
import MediaSelector from '@/core/components/form-elements/MediaSelector.vue';
import DraggableFormList from '@/core/components/form-elements/DraggableFormList.vue';
import LanguageTabs from '@/core/components/layout-elements/LanguageTabs.vue';
import { AboutContentRow } from '@/modules/content-blocks/interfaces/about-block.interface';
import { createDefaultAboutContentRow } from '@/modules/content-blocks/helpers/about-block.helper';

const model = defineModel<any>();

const props = defineProps<{
   errors: Record<string, string>;
}>();

const addRow = (data: { rows: AboutContentRow[] }) => {
   data.rows = [...data.rows, createDefaultAboutContentRow()];
};

const removeRow = (data: { rows: AboutContentRow[] }, id: string) => {
   const idx = data.rows.findIndex((row: any) => row.id === id);
   if (idx !== -1) {
      data.rows.splice(idx, 1);
   }
};
</script>

<template>
   <LanguageTabs :errors="props.errors" v-slot="{ activeLanguageName }">
      <DraggableFormList
         v-model="model.rows"
         :add-button-label="$t('live-editor.content-blocks.about.add-row')"
         @add="addRow(model as { rows: AboutContentRow[] })"
         @remove="removeRow(model as { rows: AboutContentRow[] }, $event)"
      >
         <template v-if="activeLanguageName" #title="{ item: row, index }">
            <h4>
               {{ row.title[activeLanguageName] || $t('live-editor.content-blocks.about.title') + (index + 1) }}
            </h4>
         </template>
         <template v-if="activeLanguageName" #fields="{ item: row, index }">
            <NxtInput
               :name="`rows[${index}].title.${activeLanguageName}`"
               :label="$t('live-editor.content-blocks.about.title')"
               v-model="row.title[activeLanguageName]"
               :errors="props.errors"
            />
            <NxtTextEditor
               v-plain-text-paste
               :name="`rows[${index}].description.${activeLanguageName}`"
               :key="`about-row-${row.id}-description-${activeLanguageName}`"
               :label="$t('live-editor.content-blocks.about.description')"
               :hidden-options="['align', 'font-size', 'list', 'emojis', 'reset-style', 'link']"
               :min-height="'15rem'"
               :errors="props.errors"
               v-model="row.description[activeLanguageName]"
            />
            <div>
               <MediaSelector v-model="row.image.url" v-model:media-id="row.image_id" :error="props.errors[`rows[${index}].image_id`]" />
            </div>
            <NxtToggle
               :name="`about-row-${row.id}-image-left`"
               :label="$t('live-editor.content-blocks.about.positioned')"
               v-model="row.imageLeft"
            />
         </template>
      </DraggableFormList>
   </LanguageTabs>
</template>
